import _ from 'lodash';
import '@patsnap-ui/icon/assets/solid/SortLetterAToZ.svg';
import '@patsnap-ui/icon/assets/solid/SortLetterZToA.svg';
import '@patsnap-ui/icon/assets/solid/SortNumber1To9.svg';
import '@patsnap-ui/icon/assets/solid/SortNumber9To1.svg';
import '@patsnap-ui/icon/assets/solid/SortTimeLatestToOldest.svg';
import '@patsnap-ui/icon/assets/solid/SortTimeOldestToLatest.svg';
import '@patsnap-ui/icon/assets/solid/WellNumber.svg';
import '@patsnap-ui/icon/assets/solid/SortCorr.svg';

export const SORT_TYPE = {
    NUMBER: 'NUMBER',
    STRING: 'STRING',
    DATE: 'DATE',
    RELEVANT: 'RELEVANT',
    FAMILY: 'FAMILY'
};

export const SORT_TYPE_ICON_MAP = {
    [SORT_TYPE.NUMBER]: ['SolidSortNumber1To9', 'SolidSortNumber9To1'],
    [SORT_TYPE.STRING]: ['SolidSortLetterAToZ', 'SolidSortLetterZToA'],
    [SORT_TYPE.DATE]: ['SolidSortTimeOldestToLatest', 'SolidSortTimeLatestToOldest'],
    [SORT_TYPE.RELEVANT]: ['SolidMostRelevant', 'SolidLessRelevant'],
};

export const CUSTOMFIELD_SORT_TYPE_MAP = {
    STRING: SORT_TYPE.STRING,
    OPTION: SORT_TYPE.STRING,
    NUM: SORT_TYPE.NUMBER,
    DATE: SORT_TYPE.DATE,
    RELEVANT: SORT_TYPE.RELEVANT,
};

// 申请日
const APD = {
    key: 'APD',
    options: [
        'asc',
        'desc',
    ],
    sortType: SORT_TYPE.DATE,
};

// 公开日
const PBD = {
    key: 'PBD',
    options: [
        'pasc',
        'pdesc',
    ],
    sortType: SORT_TYPE.DATE,
};

// Patsnap同族最早公开日
const EPBDT_F = {
    key: 'EPBDT_F',
    options: [
        'epbdtfasc',
        'epbdtfdesc',
    ],
    sortType: SORT_TYPE.DATE,
};

// 最早优先权日
const FIRST_FADL_DATE = {
    key: 'FIRST_FADL_DATE',
    options: [
        'fdsasc',
        'fdsdesc',
    ],
    sortType: SORT_TYPE.DATE,
};

const F_PBD = {
    key: 'F_PBD',
    options: [
        'fpasc',
        'fpdesc',
    ],
    sortType: SORT_TYPE.DATE,
};

// 授权日
const ISD = {
    key: 'ISD',
    options: [
        'isdasc',
        'isddesc',
    ],
    sortType: SORT_TYPE.DATE,
};

// 优先权日
const PRIORITY = {
    key: 'PRIORITY',
    options: [
        'fdsasc',
        'fdsdesc',
    ],
    sortType: SORT_TYPE.DATE,
};

// 预估到期日
const EXDT = {
    key: 'EXDT',
    options: [
        'exdtasc',
        'exdtdesc',
    ],
    sortType: SORT_TYPE.DATE,
};

// 申请号
const APN = {
    key: 'APN',
    options: [
        'apasc',
        'apdesc',
    ],
    sortType: SORT_TYPE.STRING,
};

// 公开号
const PN = {
    key: 'PN',
    options: [
        'pnasc',
        'pndesc',
    ],
    sortType: SORT_TYPE.STRING,
};

// 引用专利数量
const CITE_COUNT = {
    key: 'CITE_COUNT',
    options: [
        'citeasc',
        'citedesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// 被引用专利数量
const CITED_COUNT = {
    key: 'CITED_COUNT',
    options: [
        'casc',
        'cdesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// 简单同族成员数量
const SIMPLE_FAMILY_COUNT = {
    key: 'SIMPLE_FAMILY_COUNT',
    options: [
        'spasc',
        'spdesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// PatSnap同族成员数量
const EXTEND_FAMILY_COUNT = {
    key: 'EXTEND_FAMILY_COUNT',
    options: [
        'efamcasc',
        'efamcdesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// INPADOC同族成员数量
const INPADOC_FAMILY_COUNT = {
    key: 'INPADOC_FAMILY_COUNT',
    options: [
        'iasc',
        'idesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// 原始申请(专利权)人
const AN = {
    key: 'AN',
    options: [
        'fanasc',
        'fandesc',
    ],
    sortType: SORT_TYPE.STRING,
};

// 当前申请(专利权)人
const ANC = {
    key: 'ANC',
    options: [
        'fancasc',
        'fancdesc',
    ],
    sortType: SORT_TYPE.STRING,
};
// 发明人数量
const IN_COUNT = {
    key: 'IN_COUNT',
    options: [
        'inasc',
        'indesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// 权利要求数
const CLAIM_COUNT = {
    key: 'CLAIM_COUNT',
    options: [
        'claimasc',
        'claimdesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// 专利价值
const PV = {
    key: 'PV',
    options: [
        'vasc',
        'vdesc',
    ],
    sortType: SORT_TYPE.NUMBER,
};

// 相关度
const CORR = {
    key: 'CORR',
    options: [
        'sdesc',
        'sasc',
    ],
    sortType: SORT_TYPE.RELEVANT,
};

// 序列相关性
const SEQUENCE_CORRELATION = {
    key: 'SEQUENCE_CORRELATION',
    options: [
        'scdesc',
        'scasc',
    ],
    sortType: SORT_TYPE.RELEVANT,
};

// 收录时间 (属于自定义字段)
export const WS_CREATED_AT = {
    key: 'WS_CREATED_AT',
    options: [
        'wtasc',
        'wtdesc',
    ],
    sortType: SORT_TYPE.DATE,
};

// 简单同族
const FAM = {
    key: 'FAM',
    options: [
        'famdesc',
    ],
    sortType: SORT_TYPE.FAMILY,
};

// Patsnap同族
const EFA = {
    key: 'EFA',
    options: [
        'efamdesc',
    ],
    sortType: SORT_TYPE.FAMILY,
};

// inpadoc同族
const IFA = {
    key: 'IFA',
    options: [
        'ifamdesc',
    ],
    sortType: SORT_TYPE.FAMILY,
};

export const PATENT_FIELDS_MAP = {
    CORR,
    SEQUENCE_CORRELATION,
    APN,
    APD,
    FIRST_FADL_DATE,
    CITE_COUNT,
    PBD,
    EPBDT_F,
    F_PBD,
    ISD,
    PRIORITY,
    EXDT,
    PN,
    CITED_COUNT,
    SIMPLE_FAMILY_COUNT,
    EXTEND_FAMILY_COUNT,
    INPADOC_FAMILY_COUNT,
    AN,
    ANC,
    IN_COUNT,
    CLAIM_COUNT,
    PV,
    FAM,
    EFA,
    IFA,
};

export const PATENT_FIELDS_GROUP_LIST = [
    [
        FAM,
        EFA,
        IFA,
    ],
    [
        CORR,
        SEQUENCE_CORRELATION,
        APD,
        PBD,
        EPBDT_F,
        F_PBD,
        ISD,
        PRIORITY,
        EXDT,
    ],
    [
        APN,
        PN,
    ],
    [
        CITE_COUNT,
        CITED_COUNT,
        SIMPLE_FAMILY_COUNT,
        EXTEND_FAMILY_COUNT,
        INPADOC_FAMILY_COUNT,
    ],
    [
        AN,
        ANC,
    ],
    [
        IN_COUNT,
        CLAIM_COUNT,
        PV,
    ],
];

export const FAMILY_FIELDS = [
    'famdesc',
    'efamdesc',
    'ifamdesc',
];


export const SRP_PATENT_SORT_FIELD_LIST = [
    'CORR',
    'SEQUENCE_CORRELATION',
    'APN',
    'APD',
    'CITE_COUNT',
    'PBD',
    'EPBDT_F',
    'ISD',
    'PRIORITY',
    'EXDT',
    'PN',
    'CITED_COUNT',
    'SIMPLE_FAMILY_COUNT',
    'EXTEND_FAMILY_COUNT',
    'INPADOC_FAMILY_COUNT',
    'AN',
    'ANC',
    'IN_COUNT',
    'CLAIM_COUNT',
    'PV',
    'FIRST_FADL_DATE'
];

export const SRP_FAMILY_PATENT_SORT_FIELD_LIST = [
    'FAM',
    'IFA',
    'EFA',
    'APD',
    'PBD',
    'ISD',
    'PRIORITY',
    'FIRST_FADL_DATE',
    'EXDT',
    'APN',
    'PN',
    'AN',
    'ANC',
    'PV'
]

export const WORKSPACE_PATENT_SORT_FIELD_LIST = [
    'FAM',
    'IFA',
    'EFA',
    'APN',
    'APD',
    'CITE_COUNT',
    'PBD',
    'EPBDT_F',
    'F_PBD',
    'ISD',
    'PRIORITY',
    'EXDT',
    'PN',
    'CITED_COUNT',
    'SIMPLE_FAMILY_COUNT',
    'EXTEND_FAMILY_COUNT',
    'INPADOC_FAMILY_COUNT',
    'AN',
    'ANC',
    'IN_COUNT',
    'CLAIM_COUNT',
    'PV',
    'FIRST_FADL_DATE'
];
